import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_ext_RowClass} from '../../../dbschema/bl_fi_mst_coupon_ext';

export class CouponExtensionContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_ext: bl_fi_mst_coupon_ext_RowClass = new bl_fi_mst_coupon_ext_RowClass();
}
